export const TIMEMAPPER = 'timeMapper';